<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style>

    .osfQuizPrivate{
        font-family: Roboto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        min-height: 25rem;
    }

    .osfQuizPrivate h2, .osfQuizPrivate p {
        font-family: Roboto-Medium;
    }

    .osfQuizPrivate h2 {
        font-size: 1.5rem;
        color: #5F4C54;
        text-align: center;
    }

    .osfQuizPrivate p {
        font-size: 0.875rem;
    }
</style>

<template>
    <div
        class="osfQuizPrivate"
        v-html="privateHtml"
    />
</template>

<script>
export default {
    name: 'Private',
    computed: {
        privateHtml: function () {
            return this.$store.state.privateHTML;
        }
    }
};
</script>
